import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-left",
  "use": "icon-arrow-left-usage",
  "viewBox": "0 0 10 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 16\" id=\"icon-arrow-left\"><path fill-rule=\"evenodd\" d=\"M6 3L0 8l6 5v-3h4V6H6V3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol